import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
};

const addUpdatedTechnician = (list, newRecord) => {
  const oldRecordIndex = list.findIndex(
    (item) => item.technician === newRecord.technician);
  return [
    ...list.slice(0, oldRecordIndex),
    newRecord,
    ...list.slice(oldRecordIndex + 1),
  ];
};

export const technicians = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_TECHNICIAN]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
    [ActionTypes.FETCHING_TECHNICIAN]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TECHNICIAN]: (state, action) => {
      return {
        ...state,
        'loading': false,
        'list': action.response.data,
      };
    },
    [ActionTypes.FETCHED_TECHNICIAN_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.ADDING_TECHNICIAN]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDED_TECHNICIAN]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [action.response.data, ...state.list],
    }),
    [ActionTypes.ADDED_TECHNICIAN_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_TECHNICIAN]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_TECHNICIAN]: (state, action) => ({
      ...state,
      'loading': false,
      'list': addUpdatedTechnician(state.list, action.response.data),
    }),
    [ActionTypes.UPDATED_TECHNICIAN_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
